var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8754 5.51679C12.7889 5.36032 12.6621 5.22989 12.5082 5.13905C12.3542 5.04821 12.1788 5.00031 12 5.00031C11.8212 5.00031 11.6458 5.04821 11.4918 5.13905C11.3379 5.22989 11.2111 5.36032 11.1247 5.51679L4.62469 17.5168C4.54063 17.669 4.49773 17.8406 4.50022 18.0144C4.50272 18.1883 4.55051 18.3586 4.6389 18.5083C4.72728 18.6581 4.85319 18.7822 5.00421 18.8685C5.15522 18.9547 5.32611 19.0001 5.50002 19.0001H18.5C18.6739 19.0001 18.8448 18.9547 18.9958 18.8685C19.1468 18.7822 19.2728 18.6581 19.3612 18.5083C19.4495 18.3586 19.4973 18.1883 19.4998 18.0144C19.5023 17.8406 19.4594 17.669 19.3754 17.5168L12.8754 5.51679Z",
    stroke: "#D03450",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14V9.5",
    stroke: "#D03450",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5C11.8619 16.5 11.75 16.3881 11.75 16.25C11.75 16.1119 11.8619 16 12 16",
    stroke: "#D03450"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5C12.1381 16.5 12.25 16.3881 12.25 16.25C12.25 16.1119 12.1381 16 12 16",
    stroke: "#D03450"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.39ea2fdfb4d9d7e629560cdd8e50023d.svg";
export { ForwardRef as ReactComponent };